// extracted by mini-css-extract-plugin
module.exports = {"dragDrop":"FileInput_dragDrop__lyx_x","documentUploader":"FileInput_documentUploader__2pQ2Q","documentUploaderActive":"FileInput_documentUploaderActive__i14GV"};